import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "skypeConvs" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }

import { SkypeGetters, SkypeActions, SkypeMutations } from '@/store/modules/skype';
import { useRoute } from 'vue-router';
import { useStore } from 'vuex';
import { computed } from 'vue';


import { defineComponent } from 'vue';

const __default__ = defineComponent({
    name: 'SkypeConvWindow'
});


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const route = useRoute();
const store = useStore();

const projectId = computed(() => typeof (route.params.projId) === "string" ? route.params.projId : route.params.projId[0])
const targetId = computed(() => typeof (route.params.targetId) === "string" ? route.params.targetId : route.params.targetId[0]);
const skypeUserName = computed(() => {
    return store.getters[`skype/${SkypeGetters.getSkypeUserList}`];
})
const skypeUserListIsLoading = computed(() => {
    return store.getters[`skype/${SkypeGetters.getIsUsersLoading}`];
})
const skypeConvList = computed(() => {
    return store.getters[`skype/${SkypeGetters.getSkypeConvs}`];
});
const skypeConvsPagination = computed(() => {
    return store.getters[`skype/${SkypeGetters.getConvsPagination}`];
});
const isAllConvsLoaded = computed(() => {
    return store.getters[`skype/${SkypeGetters.getIsAllConvsLoaded}`];
});
const isConvsLoading = computed(() => {
    return store.getters[`skype/${SkypeGetters.getConvsLoading}`];
});
const selectedConv = computed(() => {
    return store.getters[`skype/${SkypeGetters.getSelectedConv}`];
});

const selectConv = (id: string) => {
    store.commit(`skype/${SkypeMutations.setSelectedConv}`, id);
}

const asyncGetProjectList = async (projId: string, uid: string, userName: string, isAppend: boolean) => {
    await store.dispatch(`skype/${SkypeActions.asyncGetSkypeConvs}`, { projId, uid, userName, isAppend });
};

const computeSelected = (id: string): boolean => {
    return id === selectedConv.value;
}
const loadConvs = () => {
    if (skypeUserName.value.length !== 0 && !isAllConvsLoaded.value && !skypeUserListIsLoading.value && !isConvsLoading.value) {
        const projId = projectId.value;
        const uid = targetId.value;
        const userName = skypeUserName.value[0]
        asyncGetProjectList(projId, uid, userName, true);
        store.commit(`skype/${SkypeMutations.setConvsPagination}`, { ...skypeConvsPagination.value, page: skypeConvsPagination.value.page + 1 });
    }
}


return (_ctx: any,_cache: any) => {
  const _directive_loading = _resolveDirective("loading")!
  const _directive_infinite_scroll = _resolveDirective("infinite-scroll")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(skypeConvList), (conv) => {
      return (_openBlock(), _createElementBlock("div", {
        key: conv.id
      }, [
        _createElementVNode("div", {
          class: _normalizeClass({ 'skypeConv': true, 'skypeConvActive': computeSelected(conv.id) }),
          onClick: ($event: any) => (selectConv(conv.id))
        }, [
          _createElementVNode("div", null, _toDisplayString(conv.displayName === "" ? conv.id : conv.displayName), 1)
        ], 10, _hoisted_2)
      ]))
    }), 128)),
    (_unref(isConvsLoading))
      ? (_openBlock(), _createElementBlock("p", _hoisted_3, "加载中......"))
      : _createCommentVNode("", true),
    (_unref(isAllConvsLoaded))
      ? (_openBlock(), _createElementBlock("p", _hoisted_4, "------已加载全部-------"))
      : _createCommentVNode("", true)
  ])), [
    [_directive_loading, _unref(skypeUserListIsLoading)],
    [_directive_infinite_scroll, loadConvs]
  ])
}
}

})